import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingBarcodeGeneratorConfig } from '@/data/landingConfig/landingBarcodeGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_BarcodeGenerator } from './schemaObject';

interface Props {}
const BarcodeGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_BarcodeGenerator} />
			<LandingTemplate
				data={landingBarcodeGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelBarcodeGenerator()}
			/>
		</>
	);
};

export default BarcodeGenerator;
